import React from 'react';
import ElfoVerseMascot from '../../assets/elfoverse-mascot.png';
import { DESCRIPTIONS } from './constants';

const MigrationRequirements = () => {
  return (
    <>
      <div className="mascot">
        <img src={ElfoVerseMascot} alt="ElfoVerse Mascot" />
      </div>
      <div className="existing-options-wrapper">
        <h2>Migrate to elfoA2P WhatsApp Business Platform (API)</h2>
        <p className="description">{DESCRIPTIONS.MIGRATION_REQUIREMENTS}</p>

        <div className="info-banner">
          <i className="info-icon">i</i>
          <div className="info-content">
            Your display name, quality rating, messaging limits, Official Business Account status,
            and any approved high-quality message templates will be migrated.
          </div>
        </div>

        <div className="requirements-grid">
          <div className="requirement-item">
            <h3>Your two-step verification has been disabled</h3>
            <p>
              To disable two-step verification for your WhatsApp phone number, go to{' '}
              <a href="#" className="link">
                Meta Business Manager (MBM) Business Settings page
              </a>{' '}
              with Admin Access. If you don't have access, reach out to your BSP to assist with
              deactivating it.
            </p>
          </div>

          <div className="requirement-item">
            <h3>
              Your business is verified, and both your phone number display name and WABA status
              have been approved
            </h3>
            <p>
              To check the status of your business, phone number display name, and WABA, go to your{' '}
              <a href="#" className="link">
                Meta Business Manager (MBM)
              </a>{' '}
              and access the Business Settings and WhatsApp Manager pages with admin privileges. If
              you're unable to access this information, reach out to your current Business Service
              Provider (BSP) for support.
            </p>
          </div>

          <div className="requirement-item">
            <h3>Allow pop-ups in your browser</h3>
            <p>Check and adjust your browser settings to allow pop-up displays.</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default MigrationRequirements;
